var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.204 2.007a.75.75 0 01.639.847L9.4 6h6.886l.471-3.354a.75.75 0 111.486.208L17.8 6h2.949a.75.75 0 010 1.5h-3.16l-1.265 9h1.925a.75.75 0 010 1.5h-2.136l-.471 3.353a.75.75 0 01-1.486-.21L16.075 7.5H9.19l-1.265 9H13.3l-.21 1.5H7.714l-.471 3.353a.75.75 0 01-1.486-.21L6.2 18H3.25a.75.75 0 010-1.5h3.16l1.265-9H5.75a.75.75 0 110-1.5h2.136l.471-3.354a.75.75 0 01.847-.639z",
    fill: "currentColor"
  })));
}
export default SvgNumber;